import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['input']

    declare readonly inputTarget: HTMLInputElement
    declare readonly hasInputTarget: boolean

    connect() {
        if (this.hasInputTarget) this.inputTarget.addEventListener('change', this.onChange)
        this.sync()
    }

    disconnect() {
        if (this.hasInputTarget) this.inputTarget.removeEventListener('change', this.onChange)
    }

    onChange = () => {
        this.sync()
    }

    private sync() {
        const input = this.hasInputTarget ? this.inputTarget : (this.element.querySelector('.checkbox-button') as HTMLInputElement | null)
        if (!input) return
        const label = this.resolveLabel(input)
        if (!label) return
        const activeClass = input.dataset.activeClass || ''
        const inactiveClass = input.dataset.inactiveClass || ''
        if (!activeClass || !inactiveClass) return
        if (input.checked) {
            if (inactiveClass) label.classList.remove(inactiveClass)
            if (activeClass) label.classList.add(activeClass)
        } else {
            if (inactiveClass) label.classList.add(inactiveClass)
            if (activeClass) label.classList.remove(activeClass)
        }
    }

    private resolveLabel(input: HTMLInputElement): HTMLLabelElement | null {
        const direct = this.element.querySelector(`label[for='${input.id}']`) as HTMLLabelElement | null
        if (direct) return direct
        const sibling = input.nextElementSibling as HTMLLabelElement | null
        if (sibling && sibling.tagName === 'LABEL') return sibling
        return null
    }
}


